import { BenchmarksModel } from "../../benchmarks/benchmarks-model";
import { BalanceCard } from "./balance-card";
import { Card } from "./card";
import { VarianceModel } from "./cards-model";

export class MainFcstWalkModel {
    public varianceModel: VarianceModel;
    public tabs: FcstWalkTab[];
    public tabsTree: FcstWalkTreeNode[] | undefined;
    public outcomeName: string;
    public undoAvailable: boolean;
    public redoAvailable: boolean;
    public selectedTabIx: number | undefined;
    public selectedDiagramSeriesName: string;
    public selectedGuiTabIndex: number;

    public benchmarksModel: BenchmarksModel;    //for temp storage only, loaded separately
}

export class FcstWalkTab {
    public varianceModel: VarianceModel;
    public path: number[];
    public header: string;
    public driverTypeName: string;
    public selectedGuiTabIndex: number;
    public benchmarksModel: BenchmarksModel;    //for temp storage only, loaded separately
}

export class FcstWalkTreeNode {
    public tab: FcstWalkTab;
    public children: FcstWalkTreeNode[] = [];

    constructor(tab: FcstWalkTab) {
        this.tab = tab;
    }
}

export class FcstWalkTreeBuilder {
    public static buildTree(tabs: FcstWalkTab[]): FcstWalkTreeNode[] {
        const nodeMap = new Map<string, FcstWalkTreeNode>();
        const roots: FcstWalkTreeNode[] = [];

        // Sort tabs by path depth to ensure parents are processed before children
        const sortedTabs = tabs.sort((a, b) => a.path.length - b.path.length);

        for (const tab of sortedTabs) {
            const pathKey = tab.path.join('.');
            const node = new FcstWalkTreeNode(tab);
            nodeMap.set(pathKey, node);

            if (tab.path.length === 1) {
                // Root level tab
                roots.push(node);
            } else {
                // Find parent
                const parentPath = tab.path.slice(0, -1);
                const parentKey = parentPath.join('.');
                const parent = nodeMap.get(parentKey);
                
                if (parent) {
                    parent.children.push(node);
                }
            }
        }

        return roots;
    }

    public static findNodeByPath(roots: FcstWalkTreeNode[], path: number[]): FcstWalkTreeNode | null {
        if (path.length === 0) return null;
        
        const targetRoot = roots.find(root => root.tab.path[0] === path[0]);
        if (!targetRoot) return null;
        
        if (path.length === 1) return targetRoot;
        
        return this.findNodeInSubtree(targetRoot, path, 1);
    }

    private static findNodeInSubtree(node: FcstWalkTreeNode, path: number[], currentIndex: number): FcstWalkTreeNode | null {
        if (currentIndex >= path.length) return node;
        
        const targetChild = node.children.find(child => 
            child.tab.path[currentIndex] === path[currentIndex]
        );
        
        if (!targetChild) return null;
        
        if (currentIndex === path.length - 1) return targetChild;
        
        return this.findNodeInSubtree(targetChild, path, currentIndex + 1);
    }
}